<!-- src/components/WelcomeBanner.vue -->
<template>
  <div class="welcome-banner">
    <div class="banner-container">
      <!-- Contenido principal -->
      <div class="content-wrapper">
        <!-- Mensaje de bienvenida primero -->
        <div class="welcome-message">
          <h1 class="main-title">¡Bienvenido!</h1>
          <p class="date-text">
            <Icon icon="bi:calendar-check" class="icon-calendar" />
            {{ currentDate }}
          </p>
        </div>

        <!-- Logo grande sin círculo -->
        <div class="logo-section">
          <img
            v-if="!logoError"
            class="logo-large"
            src="@/assets/logo/jj.png"
            alt="System JJ"
            @error="handleLogoError"
          />
          <span v-else class="logo-fallback-large">SJ</span>
        </div>

        <!-- Cita inspiradora -->
        <div class="quote-section">
          <Icon icon="bi:quote" class="quote-icon" />
          <p class="quote-text">{{ inspirationalQuote }}</p>
        </div>

        <!-- Botón de catálogo -->
        <button
          @click="irCatalogoProductos"
          class="catalog-button"
        >
          <Icon icon="mdi:package-variant" class="button-icon" />
          Ver Catálogo de Productos
          <Icon icon="mdi:open-in-new" class="button-icon-small" />
        </button>
      </div>

      <!-- Créditos - Abajo del todo -->
      <div class="footer-credits">
        <div class="credits-content">

          <!-- ✅ COMPAÑÍA (cliente): Jean Informática C.A. -->
          <div class="brand-section">
            <a
              href="https://www.jeaninformatico.com"
              target="_blank"
              rel="noopener noreferrer"
              class="brand-link"
            >
              <span class="brand-name">
                <span class="brand-highlight">Jean</span> Informática C.A.
              </span>
            </a>
            <span class="brand-separator">•</span>
            <span class="brand-year">{{ currentYear }}</span>
          </div>

          <!-- ✅ DESARROLLADOR: SYSTEM JJ C.A. -->
          <div class="developers-section">
            <Icon icon="mdi:code-tags" class="dev-icon" />
            <span class="dev-label">Desarrollado por</span>
            <a
              href="https://www.sistemas-jj.com"
              target="_blank"
              rel="noopener noreferrer"
              class="dev-link"
            >
              <span class="dev-name">SYSTEM JJ C.A.</span>
            </a>
          </div>

          <!-- Badge de versión -->
          <div class="version-badge">
            <span class="version-text">v2.0</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";

export default {
  name: 'WelcomeBanner',
  components: { Icon },
  props: {
    userData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      logoError: false,
      quotes: [
        "El éxito es la suma de pequeños esfuerzos repetidos día tras día",
        "La calidad no es un acto, es un hábito",
        "El mejor momento para empezar es ahora",
        "La excelencia no es una habilidad, es una actitud"
      ]
    };
  },
  computed: {
    currentDate() {
      try {
        const now = new Date();
        return now.toLocaleDateString('es-ES', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
      } catch {
        return 'Fecha no disponible';
      }
    },

    currentYear() {
      return new Date().getFullYear();
    },

    inspirationalQuote() {
      try {
        const index = Math.floor(Math.random() * this.quotes.length);
        return this.quotes[index] || "El éxito es la suma de pequeños esfuerzos";
      } catch {
        return "El éxito es la suma de pequeños esfuerzos";
      }
    }
  },
  methods: {
    handleLogoError() {
      this.logoError = true;
    },

    irCatalogoProductos() {
      this.$router.push('/catalogo-productos');
    }
  }
};
</script>

<style scoped>
/* Contenedor principal - Pantalla completa con fondo blanco */
.welcome-banner {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: #ffffff;
  position: relative;
}

.banner-container {
  width: 100%;
  max-width: 950px;
  min-height: 70vh;
  background: #fafafa;
  border-radius: 2rem;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.06), 0 8px 20px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2.5rem 2.5rem;
  border: 1px solid #f0f0f0;
}

.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
  justify-content: center;
}

/* Mensaje de bienvenida primero */
.welcome-message {
  text-align: center;
  padding: 0;
}

.main-title {
  font-size: 3rem;
  font-weight: 800;
  color: #1a1a2e;
  margin: 0;
  line-height: 1.2;
}

.date-text {
  font-size: 0.95rem;
  color: #6b7280;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.icon-calendar {
  font-size: 1rem;
  color: #8b5cf6;
}

/* Logo grande sin círculo */
.logo-section {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 0;
}

.logo-large {
  width: 380px;
  height: auto;
  max-width: 80%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.logo-large:hover {
  transform: scale(1.02);
}

.logo-fallback-large {
  font-size: 6rem;
  font-weight: 900;
  color: #4f46e5;
}

/* Cita */
.quote-section {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0;
  max-width: 500px;
}

.quote-icon {
  font-size: 1.3rem;
  color: #8b5cf6;
  flex-shrink: 0;
  margin-top: 0.1rem;
}

.quote-text {
  font-size: 0.9rem;
  color: #6b7280;
  font-style: italic;
  line-height: 1.5;
  margin: 0;
  text-align: center;
}

/* Botón de catálogo */
.catalog-button {
  background: #4f46e5;
  border: none;
  color: white;
  padding: 0.8rem 2rem;
  border-radius: 0.75rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  width: fit-content;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25);
  margin-top: 0.5rem;
}

.catalog-button:hover {
  background: #4338ca;
  transform: scale(1.05);
  box-shadow: 0 8px 25px rgba(79, 70, 229, 0.35);
}

.catalog-button:active {
  transform: scale(0.95);
}

.button-icon {
  font-size: 1.2rem;
}

.button-icon-small {
  font-size: 0.8rem;
  opacity: 0.7;
}

/* ═══════════ FOOTER CON CRÉDITOS ═══════════ */
.footer-credits {
  margin-top: 1.5rem;
  padding-top: 1.2rem;
  border-top: 2px solid #f3f4f6;
}

.credits-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
}

/* ✅ Compañía (cliente): Jean Informática C.A. */
.brand-section {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  flex-wrap: wrap;
}

.brand-name {
  color: #374151;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.brand-highlight {
  color: #4f46e5;
  font-weight: 800;
}

.brand-link {
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.brand-link:hover {
  opacity: 0.8;
}

.brand-separator {
  color: #d1d5db;
}

.brand-year {
  color: #9ca3af;
  font-weight: 400;
}

/* ✅ Desarrollador: SYSTEM JJ C.A. */
.developers-section {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.dev-icon {
  color: #c4b5fd;
  font-size: 0.85rem;
}

.dev-label {
  color: #b0b3bb;
  font-size: 0.72rem;
  font-style: italic;
}

.dev-link {
  text-decoration: none;
}

.dev-name {
  color: #4f46e5;
  font-weight: 700;
  font-size: 0.78rem;
  transition: color 0.3s ease;
}

.dev-name:hover {
  color: #4338ca;
}

/* Badge de versión */
.version-badge {
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  padding: 0.15rem 0.5rem;
  border-radius: 0.5rem;
}

.version-text {
  color: #9ca3af;
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.05em;
}

/* Responsive */
@media (max-width: 768px) {
  .banner-container {
    padding: 2rem 1.5rem;
    min-height: 80vh;
    border-radius: 1.5rem;
  }

  .content-wrapper {
    gap: 0.6rem;
  }

  .main-title {
    font-size: 2.5rem;
  }

  .logo-large {
    width: 300px;
  }

  .logo-fallback-large {
    font-size: 5rem;
  }

  .date-text {
    font-size: 0.85rem;
  }

  .catalog-button {
    padding: 0.7rem 1.5rem;
    font-size: 0.9rem;
  }

  .credits-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 0.5rem;
  }

  .developers-section {
    justify-content: center;
  }

  .brand-section {
    font-size: 0.8rem;
    justify-content: center;
  }

  .footer-credits {
    margin-top: 1rem;
    padding-top: 1rem;
  }
}

@media (max-width: 480px) {
  .banner-container {
    padding: 1.5rem 1rem;
    min-height: 90vh;
    border-radius: 1rem;
  }

  .content-wrapper {
    gap: 0.5rem;
  }

  .main-title {
    font-size: 2rem;
  }

  .logo-large {
    width: 220px;
  }

  .logo-fallback-large {
    font-size: 4rem;
  }

  .date-text {
    font-size: 0.7rem;
  }

  .quote-text {
    font-size: 0.8rem;
  }

  .quote-section {
    gap: 0.5rem;
  }

  .quote-icon {
    font-size: 1.1rem;
  }

  .catalog-button {
    padding: 0.6rem 1.2rem;
    font-size: 0.8rem;
    gap: 0.5rem;
  }

  .button-icon {
    font-size: 1rem;
  }

  .footer-credits {
    padding-top: 0.8rem;
    margin-top: 0.8rem;
  }

  .brand-section {
    font-size: 0.72rem;
    gap: 0.25rem;
  }

  .dev-name {
    font-size: 0.72rem;
  }

  .dev-label {
    font-size: 0.62rem;
  }

  .version-text {
    font-size: 0.6rem;
  }
}
</style>